/**
 * Extracts unique task types from an examination.
 *
 * This function takes an Examination object and extracts all task types from its tasks.
 * It then filters out undefined values and returns a list of unique TaskStep values.
 *
 * @param {Examination} examination - The examination object containing tasks and test data.
 * @returns {TaskStep[]} - An array of unique TaskStep values.
 *
 * Usage:
 * const uniqueTaskTypes = getUniqueTaskTypes(examination);
 */

import { Examination, TaskStep } from "graphql/types"

export const getUniqueTaskTypes = (examination: Examination): TaskStep[] => {
  const taskSteps = examination.tasks.flatMap((task) =>
    task.testDatas?.map((testData) => testData?.type)
  )
  const uniqueTaskTypes = Array.from(new Set(taskSteps))
  return uniqueTaskTypes.filter((type): type is TaskStep => type !== undefined)
}
